<!-- 角色授权 -->
<template>
	<div class="autoMenu" v-if="dialogVisible">
		<h3 class="title">角色分配</h3>
		<!-- <el-drawer title="角色分配" :visible.sync="dialogVisible"  size="600px" direction="rtl" :wrapperClosable="false"
                   class="customer-drawer-common add-edit-effect"> -->
		<div>
			<el-table
			:data="tableData"
			style="width: 100%;"
			size="mini"
			ref="multipleTable"

			@selection-change="handleSelectionChange"
			:header-cell-style="{'background-color': '#E9F0F7', 'color': '#3C4353'}">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column label="角色">
					<template slot-scope="scope">
						{{ scope.row.roleName ? scope.row.roleName : '暂无' }}
					</template>
				</el-table-column>
				<el-table-column label="角色属性">
					<template slot-scope="scope">
						暂无
					</template>
				</el-table-column>
				<el-table-column label="描述">
					<template slot-scope="scope">
						{{ scope.row.description ? scope.row.description : '暂无' }}
					</template>
				</el-table-column>
			</el-table>
			<el-pagination small
			@size-change="handleSizeChange"
			background
			@current-change="handleCurrentChange"
			:current-page="queryInfo.pageNum"
			:page-sizes="[5, 10, 20]"
			:page-size="queryInfo.pageSize"
			layout="total, sizes, prev, pager, next, jumper"
			size="mini" :pager-count="5" :total="total"
			style="margin-top: 20px;text-align: center">
			</el-pagination>
			<div class="footer">
				<el-button @click="close" size="mini">取 消</el-button>
				<el-button type="primary" size="mini" @click="save()">保 存</el-button>
			</div>
		</div>
		<!-- </el-drawer> -->
	</div>
</template>
<script>
import { roleList, roleUpdateMenu, } from '@/api/menu'
import { getRoleUpdateUserList } from '@/api/role'

export default {
	props: ['optionDatadd', 'type'],
	watch: {
		optionDatadd: {
			handler(val) {
				this.authArr = val
			},
			deep: true,
			immediate: true
		},
	},
	data() {
		return {
			dialogVisible: false,
			loading: false,
			authArr: [],
			total: 0,
			multipleSelectionAll: [],
			multipleSelection: [],
			operateData: {},
			queryInfo: {
				pageNum: 1, // 当前页数
				pageSize: 10, // 当前每页显示多少条数据
				account: "",
				nickname: "",
				roleName: "",
				datePicker: "",
				brandIdentify: '',
				ect: "",
				sct: ""
			},
			tableData: [],
			idKey: "roleId"
		}
	},
	mounted() {
		// this.getrulefenpei()
	},
	methods: {
		onAdd() {
			this.dialogVisible = true;
			this.getrulefenpei()
		},
		handleSelectionChange(val, row) {
			console.log(val);
			this.multipleSelection = val;
			// this.operateData = row;
		},
		/*selectAll(selection) {
			this.multipleSelection = selection;
		},*/

		save() {
			this.changePageCoreRecordData();
			let auths = this.authArr;
			let roles = this.multipleSelectionAll.map(item=>item.roleId);
			// console.log(`auths`,auths);
			// console.log(`roles`,roles);
			if (this.type == 'menu') {
				if (auths.length<=0 || roles.length<=0) {
					this.$message.error("请选择权限和角色")
					return false;
				}
				roleUpdateMenu({
					menuList: auths,
					roleList: roles
				}).then(res => {
					if (res.errcode == 0) {
						this.$message.success(`操作成功`);
						this.getrulefenpei();
						this.dialogVisible = false;
						this.$emit("close");
					}
				})
			} else if (this.type == 'brand') {
				// 待修改
				console.log("brand")
			} else if (this.type == 'user') {
				// 待修改
				if (!this.operateData.roleId) {
					this.$message.error("请选择一个角色后保存")
					return
				}
				getRoleUpdateUserList({
					roleId: this.operateData.roleId,
					userList: this.authArr
				}).then(res => {
					let code = res.errcode
					if (code == 0) {
						this.$message.success(res.errmsg)
						this.dialogVisible = false
						this.getrulefenpei()
						this.operateData = {}
					}
				}).catch((err) => {})
			}

		},
		async getrulefenpei() {
			this.changePageCoreRecordData();
			await roleList({
				data: {
					assistantResId: "",
					brandId: "",
					createBy: "",
					createTime: '',
					createTimeFrom: this.queryInfo.datePicker ? this.queryInfo.datePicker[0] : '',
					createTimeTo: this.queryInfo.datePicker ? this.queryInfo.datePicker[1] : '',
					description: "",
					isSelect: "",
					parentRoleId: "",
					roleId: "",
					roleName: this.queryInfo.roleName,
					state: ""
				},
				orderBy: 'create_time',
				pageNum: this.queryInfo.pageNum,
				pageSize: this.queryInfo.pageSize
			}).then(res => {
				console.log(res);
				let code = res.errcode
				if (code == 0) {
					this.tableData = res.list
					this.total = res.total

				}
			})
			this.setSelectRow();
		},
		// 监听pageSize改变的事件
		handleSizeChange(newSize) {
			this.queryInfo.pageSize = newSize
			this.getrulefenpei()
		},
		// 监听页码值改变的事件
		handleCurrentChange(newPage) {
			this.queryInfo.pageNum = newPage
			this.getrulefenpei()
		},
		close(){
			this.multipleSelectionAll = [];
			this.multipleSelection = [];
			this.dialogVisible = false;
			this.$emit("close");
		},
		//记忆选择核心方法
		changePageCoreRecordData(){
			// 标识当前行的唯一键的名称
			let idKey = this.idKey;
			let that = this;
			// 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
			if (this.multipleSelectionAll.length <= 0) {
				this.multipleSelectionAll = this.multipleSelection;
				return;
			}
			// 总选择里面的key集合
			let selectAllIds = [];
			this.multipleSelectionAll.forEach(row => {
				selectAllIds.push(row[idKey]);
			});
			let selectIds = [];
			// 获取当前页选中的id
			this.multipleSelection.forEach(row => {
				selectIds.push(row[idKey]);
				// 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
				if (selectAllIds.indexOf(row[idKey]) < 0) {
					that.multipleSelectionAll.push(row);
				}
			});
			let noSelectIds = [];
			// 得到当前页没有选中的id
			this.tableData.forEach(row => {
				if (selectIds.indexOf(row[idKey]) < 0) {
					noSelectIds.push(row[idKey]);
				}
			});
			noSelectIds.forEach(id => {
				if (selectAllIds.indexOf(id) >= 0) {
					for (let i = 0; i < that.multipleSelectionAll.length; i++) {
						if (that.multipleSelectionAll[i][idKey] == id) {
							// 如果总选择中有未被选中的，那么就删除这条
							that.multipleSelectionAll.splice(i, 1);
							break;
						}
					}
				}
			});
		},
		// 设置选中的方法
		setSelectRow() {
			if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
				return;
			}
			// 标识当前行的唯一键的名称
			let idKey = this.idKey;
			let selectAllIds = [];

			this.multipleSelectionAll.forEach(row => {
				selectAllIds.push(row[idKey]);
			});
			this.$refs.multipleTable.clearSelection();
			console.log(this.tableData);
			for (var i = 0; i < this.tableData.length; i++) {
				if (selectAllIds.indexOf(this.tableData[i][idKey]) >= 0) {
					// 设置选中，记住table组件需要使用ref="multipleTable"
					this.$refs.multipleTable.toggleRowSelection(this.tableData[i], true);
				}
			}
		}

	}
}
</script>
<style lang="scss" scoped>
.autoMenu {
	width: 600px;
	border: 1px solid #e6e9ef;
	border-radius: 4px;
	overflow: hidden;

	.title {
		height: 44px;
		line-height: 44px;
		background: #F6F7F9;
		border-bottom: 1px solid #E8E8E8;
		padding-left: 30px;
		color: #3C4353;
	}

	&>div {
		padding: 20px;
	}

	.footer{
		margin-top: 10px;
		display: flex;
		justify-content: flex-end;
	}
	/* section {
		height: calc(100vh - 200px);
		overflow-y: auto;
	}

	::v-deep .disableheadselection>.cell .el-checkbox__inner {
		display: none !important;
	} */
}
</style>